export default __webpack_public_path__ + "/dist/images/2067483.79a419adfe06b09a46db74023ecbe9a0.png";